export enum SelectionMode {
  SINGLE = 'single',
  MULTI = 'multi',
}
